import { defaultKavaProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/kava/default-constants';

export const PHOTON_SWAP_CONTRACT_ADDRESS = '0x8a340F39A468C2FcBFFf2122446a9A0745A313Ad';

export const PHOTON_SWAP_PROVIDER_CONFIGURATION = defaultKavaProviderConfiguration;
